import '@babel/polyfill'

// plugins config
import './plugins/iview.js'
import './plugins/axios.js'
import './plugins/eventHub'
import './plugins/unwatch.js'
import './plugins/extendsPrototype.js'
import router from './plugins/router'

// 数据分享插件
import sharePlugin from './plugins/share.js'
// 浮云框相关插件
import flowWindowPlugin from './plugins/flowWindow.js'

// 配置文件引用之后
import Vue from 'vue'
// Vue config
Vue.config.productionTip = false
import "swiper/swiper-bundle.css";

// vuex
import store from './store'
import App from './App.vue'
import './assets/font.less';
import './assets/default/less/index.less'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

// 引用组件动态添加删除管理器
import compManagerPlugin from './plugins/comp-manager/index';

// initConfig
import { initConfig } from './views/common/config'

Vue.prototype.$loading(true, '读取配置中...')
initConfig()
    .then(([config, shareData]) => {
        console.log('init end', config)

        // 全局配置项
        global.CONFIG = config
        console.log(global.CONFIG, 'global.CONFIG')
        global.echarts = echarts

        // 分享数据 shareData(不绑定到全局，避免外部干扰)
        Vue.use(sharePlugin, shareData)
        Vue.use(flowWindowPlugin, store)

        Vue.use(compManagerPlugin);

        // 取消默认代理
/*        GeoGlobe.ProxyHost = ''*/

        // render
        global.ROOTVM = new Vue({
            store,
            router,
            render: h => h(App)
        }).$mount('#app')
    })
    .catch(err => {
        console.error(err)
        Vue.prototype.$Message.error('配置读取错误')
    })
    .finally(() => {
        Vue.prototype.$loading(false)
    })
